import { accountRoute } from "@/pages/account/route/account";
import { allAddressPaymentRoute } from "@/pages/address-payment/route";
import { allOrderRoute } from "@/pages/history-order/route";
import { allProfileRoute } from "@/pages/profile/route";
import type { RouteRecordRaw } from "vue-router";
import { MAIN_ROUTE_NAME, NAIL_SUPPLY_ROUTE_NAME } from "@/libs/route-name";
import { affiliateReferralRoute } from "@/pages/affiliate/route";
import { aboutUsRoute } from "@/pages/about-us/route";

export const mainRoutes: RouteRecordRaw = {
  path: "/",
  component: () => import("@/layouts/main.vue"),
  redirect: {
    name: NAIL_SUPPLY_ROUTE_NAME.CATEGORY
  },
  children: [
    accountRoute(),
    aboutUsRoute(),
    affiliateReferralRoute(),
    ...allProfileRoute,
    ...allOrderRoute,
    ...allAddressPaymentRoute,
    {
      path: "/referral/:ref_code",
      name: MAIN_ROUTE_NAME.REFERRAL,
      component: () => import("@/pages/referral.vue")
    },
    {
      path: "blank-page",
      name: "blank-page",
      meta: {
        pageName: "page.dashboard"
      },
      component: () => import("@/pages/blank-page.vue")
    }
  ]
};
